import { requireAuth } from '@/auth/requireAuth'
import { ActivitiesClosingTime } from '@/components/global-summary/activities-time-closing'
import { ActivityStatuses } from '@/components/global-summary/activity-statuses'
import { CompaniesCompleted } from '@/components/global-summary/companies-completed'
import { Issues } from '@/components/global-summary/delays'
import { GlobalSummaryFilters } from '@/components/global-summary/global-summary-filters'
import { NotCompletedActivities } from '@/components/global-summary/not-completed-activities'
import { MonthSelectorWrapper } from '@/components/month-selector-wrapper'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { PageTitle } from '@/layout/page-title'
import { getPeople } from '@/people'
import type { GlobalSummaryRequest } from '@/report'
import { getClosingDate } from '@/utils/closing-date'
import { createFileRoute, useLoaderData, useSearch } from '@tanstack/react-router'


export const Route = createFileRoute('/(app)/_layout/global-summary')({
  component: RouteComponent,
  validateSearch: (search?: Record<string, unknown>): GlobalSummaryRequest => {
    // validate and parse the search params into a typed state
    const closingDate = getClosingDate();
    return {
      month: search?.month as number ?? closingDate.month, // Default to current month if not provided
      year: search?.year as number ?? closingDate.year,
      business: search?.business as string | null ?? null,
      perimeter: search?.perimeter as string | null ?? null,
      region: search?.region as string | null ?? null,
      country: search?.country as string | null ?? null,
      companyId: search?.companyId as string | null ?? null,
      personEmail: search?.personEmail as string | null ?? null,
    }
  },
  beforeLoad: requireAuth,
  loader: async () => {
    const peopleData = await getPeople();
    return { peopleData }
  },
})

function RouteComponent() {

  const search: GlobalSummaryRequest = useSearch({ from: '/(app)/_layout/global-summary' });
  const { companiesData } = useLoaderData({ from: '/(app)/_layout' })
  const { peopleData } = useLoaderData({ from: '/(app)/_layout/global-summary' });

  return (
    <div className="container max-w-[1900px] py-4 px-4 mx-auto">
      <PageTitle title="Global Summary" rightActions={
        <div className="max-w-[350px]">
          <MonthSelectorWrapper initialMonth={search.month} initialYear={search.year} />

        </div>
      }
      />
      {/* <Tabs defaultValue="closing" >
        <TabsList>
          <TabsTrigger value="closing">Closing governance</TabsTrigger>
          <TabsTrigger value="company">Company governance</TabsTrigger>
        </TabsList>
        <TabsContent value="closing"> */}
          <div>
            <GlobalSummaryFilters
              values={search}
              companies={companiesData.data ?? []}
              people={peopleData.data ?? []}
            />

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 flex-col gap-4">
              <Card >
                <CardHeader>
                  <CardTitle>Activities completion</CardTitle>
                </CardHeader>
                <CardContent>
                  <NotCompletedActivities request={search} />
                </CardContent>
              </Card>
              <Card  >
                <CardHeader>
                  <CardTitle>Activities closing time</CardTitle>
                </CardHeader>
                <CardContent >
                  <ActivitiesClosingTime request={search} />
                </CardContent>
              </Card>
              <Card >
                <CardHeader>
                  <CardTitle>Companies completed</CardTitle>
                </CardHeader>
                <CardContent className="h-full">
                  <CompaniesCompleted request={search} />
                </CardContent>
              </Card>
              <Card>
                <CardHeader>
                  <CardTitle>Activity statuses</CardTitle>
                </CardHeader>
                <CardContent className="h-full">
                  <ActivityStatuses request={search} />
                </CardContent>
              </Card>
              <Card>
                <CardHeader>
                  <CardTitle>Issues</CardTitle>
                </CardHeader>
                <CardContent className="h-full">
                  <Issues request={search} />
                </CardContent>
              </Card>
            </div>
          </div>
        {/* </TabsContent>
        <TabsContent value="company">
          <div>TBD</div>
        </TabsContent>
      </Tabs> */}
    </div>

  )
}
